'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _jsxFileName = 'src/components/SectionWrapper/SectionWrapper.js';

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./SectionWrapper.css');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var propTypes = {
  title: _propTypes2.default.string,
  note: _propTypes2.default.string
};
var defaultProps = {
  title: null,
  note: null
};

var SectionWrapper = function (_PureComponent) {
  _inherits(SectionWrapper, _PureComponent);

  function SectionWrapper() {
    _classCallCheck(this, SectionWrapper);

    return _possibleConstructorReturn(this, (SectionWrapper.__proto__ || Object.getPrototypeOf(SectionWrapper)).apply(this, arguments));
  }

  _createClass(SectionWrapper, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          className = _props.className,
          title = _props.title,
          children = _props.children,
          note = _props.note;
      return _react2.default.createElement('div', {
        className: (0, _classnames2.default)('SectionWrapper', className),
        __source: {
          fileName: _jsxFileName,
          lineNumber: 26
        },
        __self: this
      }, title && _react2.default.createElement('h3', {
        className: 'SectionWrapper-title',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 27
        },
        __self: this
      }, title), children, note && _react2.default.createElement('p', {
        className: 'SectionWrapper-note',
        __source: {
          fileName: _jsxFileName,
          lineNumber: 29
        },
        __self: this
      }, note));
    }
  }]);

  return SectionWrapper;
}(_react.PureComponent);

SectionWrapper.propTypes = propTypes;
SectionWrapper.defaultProps = defaultProps;
exports.default = SectionWrapper;